// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * SUREnet documenten-public API
 * OpenAPI spec version: 1
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type { CollectionResultOfDocumentenTypeGetDocumentTypesByDocumentSoortenDto } from '../model/collectionResultOfDocumentenTypeGetDocumentTypesByDocumentSoortenDto';

import type { SelectableDocumentTypesGetParams } from '../model/selectableDocumentTypesGetParams';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Geeft alle documenttypes terug die selecteerbaar zijn voor een specifiek soort document.
 */
export const selectableDocumentTypesGet = (
  params?: MaybeRef<SelectableDocumentTypesGetParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customInstance<CollectionResultOfDocumentenTypeGetDocumentTypesByDocumentSoortenDto>(
    { url: `/api/v1/documenten/selecteerbare-types`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getSelectableDocumentTypesGetQueryKey = (
  params?: MaybeRef<SelectableDocumentTypesGetParams>,
) => {
  return ['api', 'v1', 'documenten', 'selecteerbare-types', ...(params ? [params] : [])] as const;
};

export const getSelectableDocumentTypesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof selectableDocumentTypesGet>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<SelectableDocumentTypesGetParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof selectableDocumentTypesGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getSelectableDocumentTypesGetQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof selectableDocumentTypesGet>>> = ({
    signal,
  }) => selectableDocumentTypesGet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof selectableDocumentTypesGet>>,
    TError,
    TData
  >;
};

export type SelectableDocumentTypesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof selectableDocumentTypesGet>>
>;
export type SelectableDocumentTypesGetQueryError = ErrorType<unknown>;

/**
 * @summary Geeft alle documenttypes terug die selecteerbaar zijn voor een specifiek soort document.
 */

export function useSelectableDocumentTypesGet<
  TData = Awaited<ReturnType<typeof selectableDocumentTypesGet>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<SelectableDocumentTypesGetParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof selectableDocumentTypesGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSelectableDocumentTypesGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
